<template>
    <div class="col-lg-12">
        <div class="card stretch stretch-full">
            <div class="card-header">
                <h5 class="card-title">Kullanıcılar Listesi</h5>
                <div class="card-header-action">
                    <div class="card-header-btn">
                        <div data-bs-toggle="tooltip" title="Yenile">
                            <button @click="fetchData()" class="avatar-text avatar-xs bg-warning"
                                data-bs-toggle="refresh"> </button>
                        </div>
                        <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                            <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success"
                                data-bs-toggle="expand"> </a>
                        </div>
                    </div>
                    <div class="dropdown">
                        <a href="javascript:void(0);" class="avatar-text avatar-sm" data-bs-toggle="dropdown"
                            data-bs-offset="25, 25">
                            <div data-bs-toggle="tooltip" title="Seçenekler">
                                <i class="feather-more-vertical"></i>
                            </div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <router-link to="/user/add" class="dropdown-item"><i class="feather-plus-circle"></i>Yeni
                                Ekle</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body custom-card-action p-0">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th scope="col">Kullanıcı Adı</th>
                                <th scope="col">İsim</th>
                                <th scope="col">Soyisim</th>
                                <th scope="col">E-Posta</th>
                                <th scope="col">Grubu</th>
                                <th scope="col" class="text-end">İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="user in users" :key="user.id">
                                <td>
                                    <div class="hstack gap-3">
                                        <div class="avatar-text bg-soft-primary text-primary">
                                            <i class="feather-book-open"></i>
                                        </div>
                                        <div>
                                            <router-link :to="{ name: 'SupplierEdit', params: { id: user.id } }"
                                                class="d-block mb-1">{{ user.username }}</router-link>
                                        </div>
                                    </div>
                                </td>
                                <td>{{ user.first_name }}</td>
                                <td>{{ user.last_name }}</td>
                                <td>{{ user.email }}</td>
                                <td>{{ user.groups }}</td>
                                <td>
                                    <div class="hstack gap-2 justify-content-end">
                                        <router-link :to="{ name: 'UserEdit', params: { id: user.id } }"
                                            class="avatar-text avatar-md bg-orange">
                                            <i class="feather-eye fs-16"></i>
                                        </router-link>
                                        <a href="#" @click="deactiveUser(user.id)" class="avatar-text avatar-md bg-red">
                                            <i class="feather-user-x fs-16"></i>
                                        </a>

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer">
                <Pagination :currentPage="currentPage" :totalPages="totalPages" :next="next" :previous="previous"
                    @page-changed="fetchData" />
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import Pagination from '@/components/common/Pagination.vue';

export default {
    name: 'UserTable',
    components: {
        Pagination
    },
    data() {
        return {
            users: [],
            currentPage: 1,
            totalPages: 1,
            recordCount: 0,
            next: true,
            previous: false
        }
    },
    async mounted() {
        const page = Number(this.$route.params.page) || 1;
        await this.fetchData(page);
    },
    watch: {
        '$route.params.page'(newPage) {
            this.fetchData(Number(newPage));
        }
    },
    methods: {
        async fetchData(page = 1) {
            console.log('fetch data called');
            try {
                const response = await this.$axios.get(`user/?page=${page}`);
                console.log('response:', response.data.results);
                this.users = response.data.results;
                this.totalPages = Math.ceil(response.data.count / 10);
                this.recordCount = response.data.count;
                this.currentPage = page;
                this.next = response.data.next;
                this.previous = response.data.previous;
            } catch (error) {
                Swal.fire('Hata!', `${error}`, 'error');
            }
        },
        async deactiveUser(id) {
            const result = await Swal.fire({
                title: "Silmek istediğinizden emin misiniz?",
                text: "Kullanıcı artık giriş yapamayacak.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Evet, sil!",
                cancelButtonText: "Hayır, iptal et"
            });

            if (result.isConfirmed) {
                try {
                    await this.$axios.delete(`user/${id}/`);
                    Swal.fire("Başarılı!", "Kayıt silindi.", "success");
                    this.fetchData();
                } catch (err) {
                    try {
                        await this.$axios.patch(`user/${id}/`, { is_active: false });
                        Swal.fire("Başarılı!", "Kayıt silindi.", "success");
                        this.fetchData();
                    } catch (error) {
                        console.log(error);
                    }
                    console.error(err);
                }
            }
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }
    }
}
</script>